import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { brand } from 'src/app/models/brand';
import { Category } from 'src/app/models/category';
interface FilterData {
  brands: brand[];
  [key: string]: unknown[];
}

interface CurrentFilters {
  brands: string[];
  [key: string]: unknown;
}

@Component({
  selector: 'megastore-admin-filters',
  templateUrl: './filters.component.html',
  styleUrls: ['./filters.component.scss']
})
export class FiltersComponent {

  public dataArray: Array<[string, unknown[]]> = [];
  public filterForm: FormGroup;
  public hasActiveFilters = false;
  public categories: Array<Category> = [];
  public vendors: Array<any> = [];
  public isApproved: Array<any> = [];
  public byMegaStore: Array<any> = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      data: FilterData,
      currentFilters?: CurrentFilters
    },
    private dialogRef: MatDialogRef<FiltersComponent>,
    private fb: FormBuilder
  ) {
    this.dataArray = Object.entries(data.data);
    this.categories = data.data['categories'] as Array<Category>;
    this.vendors = data.data['vendors'] as Array<any>;
    this.isApproved = data.data['isApproved'] as Array<any>;
    this.byMegaStore = data.data['byMegaStore'] as Array<any>;
    // Initialize form with current filters if they exist
    const initialBrands = data.currentFilters?.brands || [];
    const initialCategories = (data.currentFilters?.['categories'] || []) as unknown[];
    const initialVendors = (data.currentFilters?.['vendors'] || []) as unknown[];
    const initialIsApproved = (data.currentFilters?.['isApproved'] || []) as unknown[];
    const initialByMegaStore = (data.currentFilters?.['byMegaStore'] || []) as unknown[];
    this.hasActiveFilters = initialBrands.length > 0 || initialCategories.length > 0 || initialVendors.length > 0 || initialIsApproved.length > 0 || initialByMegaStore.length > 0;
    
    this.filterForm = this.fb.group({
      brands: [initialBrands],
      categories: [initialCategories],
      vendors: [initialVendors],
      isApproved: [initialIsApproved],
      byMegaStore: [initialByMegaStore]
    });
  }

  getBrandsFromItem(item: [string, unknown[]]): brand[] {
    return item[0] === 'brands' ? item[1] as brand[] : [];
  }

  applyFilters(): void {
    this.dialogRef.close(this.filterForm.value);
  }

  clearFilters(): void {
    this.filterForm.reset({
      brands: [],
      categories: [],
      vendors: [],
      isApproved: [],
      byMegaStore: []
    });
    this.hasActiveFilters = false;
  }

  cancelDialog(): void {
    this.dialogRef.close();
  }
}
